import React, { useEffect, useLayoutEffect, useRef, useState } from "react";

import {
  RideGlDebitCardSolid,
  RideGlInformationSolid,
  RideInformativePopover,
  RideCheckbox,
} from "@rimac-seguros/ride-system-components";
import { useDispatch, useSelector } from "react-redux";
import { Checkout } from "checkout-component-react";
import { useForm } from "react-hook-form";

import { FormControlCheckout } from "@/components/atoms/FormControlCheckout";
import { ErrorMessage } from "@/components/atoms/ErrorMessage";
import { useCheckout } from "../../hooks/useCheckout";
import { configVisaDecode } from "@/utils/awsConfig";
import { StateMachine } from "@/utils/consts";
import { setViewModalError } from "@/redux/actions/global";
import helpers from "@/utils/helpers";
import { htmlLoadingWithImage } from "@/utils/checkout";
import { getProductOptions } from "@/utils/product";

export const FormCheckout = ({
  errorStep,
  nextStep,
  initialStep,
  terms,
  setModalErrorData,
}) => {
  const { digitalDataProductName } = getProductOptions();
  const session = useSelector((state) => state.token.session);
  const userData = useSelector((state) => state.vida.userData);
  const { planSelected, typeOfFinancing } = useSelector((state) => state.plans);
  const { state } = useSelector((state) => state.global);
  const currency = useSelector((state) => state.plans.currencyPlan);

  const isEmbedded = userData.indPrevPageApp;

  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(true);

  const { register, watch } = useForm({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      terms: false,
    },
  });

  const btnPaymentRef = useRef(null);
  const cardRef = useRef(null);
  const expiryRef = useRef(null);
  const cvvRef = useRef(null);
  const subscription = watch("terms");

  const { checkoutRpta } = useCheckout({
    errorStep,
    nextStep,
    initialStep,
    setModalErrorData,
  });

  useLayoutEffect(() => {
    if (session) {
      handleInitCheckout();
      window.intentos = 0;
      window.intentosSesion = 0;
    }
  }, []);

  useEffect(() => {
    if (isEmbedded) {
      helpers.sendMessageToApp("EMBEDDED-APP-SHOW-TOPBAR");
    }
    return () => {
      window.checkoutRpta = (_) => console.log("Checkout Unmounted ", _);
    };
  }, []);

  useEffect(() => {
    if (state === StateMachine[4]) {
      return dispatch(setViewModalError(true));
    }
  }, [state]);

  useEffect(() => {
    setTimeout(() => {
      const btnPayment = document.getElementById("btnPayment");
      if (btnPayment) {
        btnPayment.classList.add("disabled");
      }
    }, 0);
  }, [btnPaymentRef.current]);

  useEffect(() => {
    setTimeout(() => {
      const btnPayment = document.getElementById("btnPayment");
      if (subscription) {
        btnPayment && btnPayment.classList.remove("disabled");
      } else {
        btnPayment && btnPayment.classList.add("disabled");
      }
    }, 200);
  }, [btnPaymentRef.current, subscription]);

  const handleInitCheckout = () => {
    window.CheckoutJS.publicKey = String(configVisaDecode[0].value);
    window.CheckoutJS.sessionToken = String(session);
    window.CheckoutJS.settings({
      reference: {
        numId: userData?.tercero ?? null,
        codigoProducto: "6",
        ideTransaccion: planSelected?.idCotizacion ?? null,
        idePlan: planSelected?.planId ?? null,
      },
      operation: "payment",
      currency: currency === "SOL" ? "PEN" : currency,
      amount: (typeOfFinancing?.valor ?? 1).toString(),
      callback: "checkoutRpta",
      name: userData?.nombres,
      lastName: userData?.apellidoPaterno,
      email: userData?.email,
      runtime: "node",
      subscription: true,
      htmlLoading: htmlLoadingWithImage,
      attributes: ["required"],
    });

    window.checkoutRpta = checkoutRpta;
    setIsLoading(false);
  };

  const mappingTagAction = () => {
    helpers.setActionTag({
      group: digitalDataProductName,
      category: "Resumen y pago",
      action: "click",
      label: "Checkbox – Autorizar cargo automático",
    });
  };

  return !isLoading ? (
    <div>
      <h3 className="ride-sys-text-title-xlarge-default mb-ride-gl-spacing-2xlarge lg:ride-sys-text-title-2xlarge-default">
        Datos de la tarjeta
      </h3>
      <div className="grid grid-cols-2 gap-ride-gl-spacing-2xlarge">
        <FormControlCheckout
          className="col-span-full"
          label="Nro de tarjeta"
          htmlFor="checkout[card]"
          glyph={<RideGlDebitCardSolid />}
          informativePopover={
            <RideInformativePopover
              glyph={<RideGlInformationSolid />}
              aria-label="Información"
              isNonModal
              paragraph="Recuerda activar las compras por internet de tu tarjeta"
              size="small"
            />
          }
        >
          <Checkout ref={cardRef} type="card" />
        </FormControlCheckout>
        <FormControlCheckout
          className="col-span-1"
          label="MM/AA"
          htmlFor="checkout[expiry]"
        >
          <Checkout ref={expiryRef} type="expiry" />
        </FormControlCheckout>
        <FormControlCheckout
          className="col-span-1"
          label="CVV"
          htmlFor="checkout[cvv]"
          informativePopover={
            <RideInformativePopover
              glyph={<RideGlInformationSolid />}
              aria-label="Información"
              isNonModal
              size="small"
              src="/ventadigital/devolucion/assets/vida-devolucion/payment/tooltip-cvv.png"
              paragraph="Es el código de tres o cuatro números que se encuentra al reverso de la tarjeta de débito o crédito. Si usas CVV dinámico, revisa en la app de tu banco."
            />
          }
        >
          <Checkout ref={cvvRef} type="cvv" />
        </FormControlCheckout>
      </div>
      <ErrorMessage message="" id="validMessage" />
      <div className="flex gap-ride-gl-spacing-large my-ride-gl-spacing-2xlarge">
        <RideCheckbox
          {...register("terms", {
            required: true,
            onChange: (e) => {
              if (e.target.checked) mappingTagAction();
            },
          })}
          size="small"
        >
          <p
            className="ride-sys-text-paragraph-small-default"
            dangerouslySetInnerHTML={{ __html: terms }}
          />
        </RideCheckbox>
      </div>
      <Checkout ref={btnPaymentRef} type="button" className="btn-payment-vcd" />
    </div>
  ) : null;
};
